module.exports = __webpack_public_path__ + "img/googleplay.3b5a9061.svg";